@import '~@splidejs/splide/dist/css/splide.min.css';
@import '~@splidejs/splide-extension-video/dist/css/splide-extension-video.min.css';

@include section-styles(0px, 0px);

section {
  max-width: 100vw;
  overflow-x: hidden;
  user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-select: none;

  &.banner {
    padding: 0;
    margin: 0;

    .section-inner {
      padding: 0;
      margin: 0;
      max-width: 100%;

      .splide__slide__content {
        padding: 0 15px;
        margin: 0 auto;
        top: unset;
        bottom: 15%;
        justify-content: end;
      }
    }
  }

  &.navOutside {
    overflow-x: visible;

    .splide__arrow--prev {
      left: -50px;
    }

    .splide__arrow--next {
      right: -50px;
    }

    .splide__pagination {
      bottom: -2rem;
    }
  }

  &.arrow-bottom {

    .section-inner {
      padding-bottom: var(--section-padding);
    }

    .splide {
      display: grid;
    }

    .splide__track {
      grid-template-columns: 1fr;
      grid-template-rows: 1fr;
      overflow-x: hidden;
    }

    .is-overflow {
      padding-bottom: -4em;
    }

    .splide__arrows {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-row: 2;
      position: relative;

      justify-content: center;
      flex-wrap: wrap;
      gap: 10px;
      /*bottom: calc(var(--section-padding) * (-1));*/
    }

    .splide__arrow--prev {
      position: relative;
      justify-self: end;
      top: unset;
      left: unset;
      transform: unset;
    }

    .splide__arrow--next {
      position: relative;
      justify-self: start;
      top: unset;
      right: unset;
      transform: unset;
    }

    .splide__pagination {
      display: none;
    }
  }

  .btn-wrapper {
    .button {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

@include container('.section-inner');

p, h1, h2, h3, h4 {
    @include text-main;
    color: var(--color-dark-grey);
    font-size: var(--font-size-main-text);
    width: 100%;
}

h3 {
  @include text-bold;
  @include h2;
  color: var(--color-darker-grey);
  margin: 0 0 12px 0;
  padding: 0;
  word-wrap: break-word;
}

p {
    color: var(--font-color-main);

    .hl-bold {
        @include text-bold;
        color: var(--color-dark-grey);
    }

    .caption {
        color: var(--color-dark-grey);
    }

    .light-caption {
      color: var(--color-grey);
      font-size: var(--font-size-small-text);
    }

    .dark-caption {
      color: var(--color-darker-grey);
    }

    .text-direction {
      display: block;

      &.left {
        text-align: left;
      }

      &.right {
        text-align: right;
      }

      &.center {
        text-align: center;
      }
    }
}

.slide-image {
    height: 200px;
}

.splide__slide:focus-visible {
    outline: none;
}

.is-playing {
  .splide__slide {
    &.video {
      .splide__slide__container:after {
        display: none;
      }
    }
  }
}

.splide__slide {
    > * > a {
      text-decoration: none;
    }

    &.video {
        .splide__slide__container:after {
            color: var(--color-white);
            font-family: var(--font-icons);
            font-size: var(--font-size-icon-xl);
            font-weight: normal;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            content: "\E916";
        }
    }

    &.text-center {
        height: fit-content;

        .splide__slide__content {
            position: absolute;
            height: 100%;
            width:  100%;
            top: 0;
            left: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;

            .splide__slide__button {
              padding-top: 15px;
            }

            p {
                padding: 0;
                margin: 0;
                color: var(--color-white);
                font-size: 36px;

                .h1 {
                  @include text-bold;
                  font-size: 54px;
                }
            }
        }
    }
}
@include media-max-width($breakpoint-m) {
  .splide__slide {
    &.text-center {
      .splide__slide__content {
        p {
          @include p;
          .h1 {
            font-size: 26px;
          }
        }
      }
    }
  }
}

.splide__slide__container {
    display: flex;
    align-items: center;
    overflow: hidden;
    position: relative;

    &.pointer {
      cursor: pointer;

      &:hover img {
        opacity: .5;
      }
    }

    .overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }

    img {
        width: 100%;
        height: auto;
        -webkit-transition: .3s ease-in-out;
        transition: .3s ease-in-out;
        opacity: 1;

        &.landscape {
          width: auto;
          height: 100%;
          margin: auto;
        }
    }
}

.splide__arrow  {
  border-radius: 100%;
  padding: 10px;
  height: 20px;
  width: 20px;
  box-sizing: content-box;

  svg {
    height: 1.4em;
    width: 1.4em;
  }
}

.splide__track.show-overflow {
    overflow: visible;
}

.thumbnails .splide__slide img {
    width: 100%;
    height: auto;
}

/* Progressbar */
.splide__progress {
  position: relative;

  .splide__custom__progress__bar {
    top: -16px;
    position: absolute;
    background-color: transparent;
    height: 3px;
    width: 100%;

    ul {
      padding: 0;
      margin: 0;
      width: 100%;
      height: 3px;
      align-items: stretch;
      justify-content: space-between;
      list-style: none outside none;
      display: flex;
      flex-direction: row;
      gap: 4rem;

      li {
        width: 100%;
        height: 100%;
        flex: 0 1 auto;
        display: block;
        list-style-type: none;

        div {
          width: 0;
          height: 3px;
          background-color: var(--color-red);
          border-radius: 4px;
        }
      }
    }
  }
}

/* Style, if gallery is not full */
.splide:not( .is-overflow ) {
    .splide__arrows {
        display: none;
    }

    .splide__list {
        justify-content: center;
    }

    .splide__slide:last-child {
        margin: 0 !important;
    }
}

/* Hide caption in overview */
.splide__slide__content__hidden {
    display: none;
}

/* pagination */
.splide__pagination {
    button {
      background: var(--color-grey);

      &.is-active {
        background: var(--color-dark-grey);
      }
    }
}

/* Pagination numbers */
.splide__pagination--custom {
  bottom: -4rem !important;

  button {
    align-items: center;
    border-radius: 4px;
    color: var(--color-light-grey);
    display: inline-flex;
    font-family: Splide Heading,sans-serif;
    font-size: 1.1rem; /* responsive button */
    height: 2.2rem;
    justify-content: center;
    line-height: 1;
    margin-left: .5rem;
    width: 2.2rem;
  }
}
